module.exports = __webpack_public_path__ + "media/customizations/sienna/back-d50179eb90418bfa3d1207b1d6f5f58a.jpg";